module.exports = __webpack_public_path__ + "img/24.52e37bff.gif";